<template>
  <div id="app">
    <router-view />
    <vue-progress-bar />
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
const Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
(function () {
  const s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = 'https://embed.tawk.to/6061d944067c2605c0bd524a/1f1v3hehr';
  s1.charset = 'UTF-8';
  s1.setAttribute('crossorigin', '*');
  s0.parentNode.insertBefore(s1, s0);
})();
</script>
